export const offerCards = [
  {
    date: '12th July',
    image:
      'https://assets.clear.in/cleartax/images/1688638646_group1814218561.svg',
    percentage: '55%',
    description:
      'On tax filing for crypto, capital gains, NRI income, ESOPs and RSUs',
    coupon: 'COUPON123',
  },
  {
    date: '13th July',
    image:
      'https://assets.clear.in/cleartax/images/1688638599_group1814218550.svg',
    percentage: '55%',
    description:
      'On tax filing for freelancers, SME owners, lawyers and doctors',
    coupon: 'COUPON123',
  },
  {
    date: '14th July',
    image:
      'https://assets.clear.in/cleartax/images/1688638697_group1814218551.svg',
    percentage: '55%',
    description: 'For all filers',
    coupon: 'COUPON123',
  },
];

export const secondFoldOffers = [
  {
    date: '12th July',
    title: 'Upto ₹3,500 off',
    description:
      'on flights (No minimum booking amount) Crypto, capital gains, NRI income, ESOPs and RSUs',
    image:
      'https://assets.clear.in/cleartax/images/1688638646_group1814218561.svg',
    brand: 'ixigo',
  },
  {
    date: '13th July',
    title: '12% off upto ₹5,000',
    description:
      'on a minimum booking of ₹2,500 for freelancers, SME owners, lawyers and doctors',
    image:
      'https://assets.clear.in/cleartax/images/1688642670_group1814218571.svg',
    brand: 'yatra',
  },
  {
    date: '14th July',
    title: 'Flat ₹175 off',
    description: 'on orders of ₹799 and above for all filers',
    image:
      'https://assets.clear.in/cleartax/images/1688642596_group1814218572.svg',
    brand: 'swiggy',
  },
];
